import { createFileRoute } from "@tanstack/react-router";

import AuditResponsePage from "@/features/dashboard/pages/audit-response";

export const Route = createFileRoute("/(app)/dashboard/audit-response/")({
  component: () => <AuditResponsePage />,
});
